var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-input',{ref:"input",attrs:{"prefixIcon":!!_vm.searchIcon?'link-icon-search':null,"placeholder":_vm.$t('LinkFilter.searchKey')+'...',"value":_vm.dynamicFilter.value.val},on:{"enter":_vm.lv_enter,"click-suffix-icon":_vm.lv_clear}})}
var staticRenderFns = []

export { render, staticRenderFns }